import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2495e7ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "bottom" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-down accordion" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "navigation-children"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-sidebar", { collapsed: _ctx.collapsed }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["navigation-items", { collapsed: _ctx.collapsed }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredNavs, (item, i) => {
        return (_openBlock(), _createElementBlock("div", { key: i }, [
          _createVNode(_component_router_link, {
            class: _normalizeClass(["navigation-item", { active: _ctx.active == item.path }]),
            to: item.path
          }, {
            default: _withCtx(() => [
              (item.icon)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: _normalizeClass(item.icon),
                    style: {"margin-right":"10px"}
                  }, null, 2))
                : _createCommentVNode("", true),
              (!_ctx.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.label), 1))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["class", "to"])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredBottomNavs, (item, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, [
            (item.children)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "navigation-item",
                  onClick: ($event: any) => (_ctx.expandChildren(item.label))
                }, [
                  (item.icon)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(item.icon),
                        style: {"margin-right":"10px"}
                      }, null, 2))
                    : _createCommentVNode("", true),
                  (!_ctx.collapsed)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.label), 1))
                    : _createCommentVNode("", true),
                  _hoisted_5
                ], 8, _hoisted_3))
              : _createCommentVNode("", true),
            (_ctx.childrenExpanded.includes(item.label))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, p) => {
                    return (_openBlock(), _createElementBlock("div", { key: p }, [
                      (child.roles?.includes(_ctx.userRole))
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: _normalizeClass(["navigation-item", { active: _ctx.$route.path == child.path }]),
                            to: child.path
                          }, {
                            default: _withCtx(() => [
                              (!_ctx.collapsed)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(child.label), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["class", "to"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (item.children == null)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  class: _normalizeClass(["navigation-item", { active: _ctx.active == item.path }]),
                  to: item.path
                }, {
                  default: _withCtx(() => [
                    (item.icon)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass(item.icon),
                          style: {"margin-right":"10px"}
                        }, null, 2))
                      : _createCommentVNode("", true),
                    (!_ctx.collapsed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.label), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["class", "to"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ], 2),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
}